var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "92",
      "height": "68",
      "viewBox": "0 0 92 68",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M81.117 56.315c-5.804-7.186-6.752-8.339-9.839-11.996-2.335-2.769-4.64-4.782-7.423-6.098 14.83-3.365 19.413-10.857 19.413-18.859C83.268 7.49 69.294.48 39.108.48v.192C49.12 1.979 59.525 5.977 59.525 19.344c0 8.193-5.343 14.774-20.054 16.723h-.21v.25c3.239.87 5.588 2.346 8.696 6.622 3.104 4.277 17.539 24.452 17.539 24.452H92v-.169c-3.525-2.486-5.198-3.87-10.879-10.907h-.004zM27.934 56.417V.487H0v.177c3.797 2.5 5.154 5.797 5.154 10.793l.136 44.96c0 4.996-1.493 8.297-5.29 10.793v.178h32.953v-.178c-3.662-2.496-5.014-5.797-5.014-10.793h-.005z",
      "fill": "#F1D5AA"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }